import { IsNotEmpty, IsString, IsUUID } from 'class-validator';

export interface TemporaryAccessDto {
  healthRecordId: string;
  access: boolean;
}

export class CreateTemporaryAccessDto {
  @IsUUID()
  healthRecordId: string;

  @IsString()
  @IsNotEmpty()
  reasonForTemporaryAccess: string;
}
